export default "__VITE_ASSET__CZEE0mL4__"